module.exports = __webpack_public_path__ + "img/HY2701-84.b8f14178.jpg";